import { walkthroughSlice } from '../WalkthroughStore'
import useSliceWrapper from './useSliceWrapper'

const useGetMethodsAndData = () => useSliceWrapper('walkthrough', walkthroughSlice)

export const useWalkthroughSlice = (): ReturnType<typeof useGetMethodsAndData> =>
  useGetMethodsAndData()

export default useWalkthroughSlice
